import { CXoneAgentEvent } from './cxone-agent-event';

/**
 * Model class for agent unavailable code event
 */
export class UpdateUnavailableCodeEvent extends CXoneAgentEvent {
  /**
   * The parse method will take the data object and assign the values to the updateUnavailableCodeEvent class properties
   * @param data - Data object received
   * @example -
   * ```
   * parse(data);
   * ```
   */
  public parse(data: { [key: string]: string }): void {
    this.iisHost = data.IISHost;
    this.vcHost = data.VCHost;
  }

}
